import { render, staticRenderFns } from "./AlertOverview.vue?vue&type=template&id=5e8b9653&scoped=true&"
import script from "./AlertOverview.vue?vue&type=script&lang=js&"
export * from "./AlertOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b9653",
  null
  
)

export default component.exports